import { useState } from "react";
import { Link } from "react-router-dom";

const quickLinks = [
  { label: "首页", to: "/" },
  { label: "今日更新", to: "/#update" },
  { label: "热门排行", to: "/#rank" },
  { label: "关于我们", to: "/about" },
];

const catLinks = [
  { label: "萌系漫画", to: "/category/mengxi" },
  { label: "甜宠漫画", to: "/category/tianchong" },
  { label: "恋爱漫画", to: "/category/lianai" },
  { label: "全部漫画", to: "/category/all" },
];

const SUBMIT = "https://readdy.ai/api/form/da20hodv7gurs51ef2gg";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [message, setMessage] = useState("");

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = String(formData.get("website_alt") || "").trim();
    if (honeypot) {
      setStatus("success");
      setMessage("订阅成功，甜宠日报将每日送达你的邮箱。");
      return;
    }
    try {
      const payload = new URLSearchParams();
      const mail = String(formData.get("email") || "").trim();
      if (mail) payload.set("email", mail);
      const res = await fetch(SUBMIT, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });
      const responseText = await res.text();
      let parsed: any = null;
      try {
        parsed = responseText ? JSON.parse(responseText) : null;
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
      if (res.ok && parsed?.code === "OK") {
        setStatus("success");
        setMessage(serverMsg || "订阅成功，甜宠日报将每日送达你的邮箱。");
        setEmail("");
      } else {
        setStatus("error");
        setMessage(serverMsg || "订阅失败，请稍后再试。");
      }
    } catch {
      setStatus("error");
      setMessage("网络异常，请稍后再试。");
    }
  };

  return (
    <footer className="bg-secondary-800 text-secondary-50">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-secondary-500 text-secondary-950">
                <i className="ri-ghost-smile-line text-xl" />
              </span>
              <span className="font-heading text-xl">可可漫画网</span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-secondary-200">
              专注萌系少女与甜宠题材的在线漫画阅读平台，收录可爱画风、软萌角色的恋爱漫画，每日更新，点开即看。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {["ri-weibo-line", "ri-qq-line", "ri-wechat-line", "ri-bilibili-line"].map((ic) => (
                <a
                  key={ic}
                  href="#"
                  aria-label="社交平台"
                  rel="nofollow"
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-700/60 text-secondary-100 transition-colors hover:bg-secondary-500 hover:text-secondary-950"
                >
                  <i className={`${ic} text-lg`} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-label text-sm font-bold tracking-wide text-secondary-100">快捷导航</h3>
            <ul className="mt-4 space-y-3">
              {quickLinks.map((l) => (
                <li key={l.label}>
                  <Link to={l.to} className="text-sm text-secondary-300 transition-colors hover:text-secondary-50">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-label text-sm font-bold tracking-wide text-secondary-100">漫画分类</h3>
            <ul className="mt-4 space-y-3">
              {catLinks.map((l) => (
                <li key={l.label}>
                  <Link to={l.to} className="text-sm text-secondary-300 transition-colors hover:text-secondary-50">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-label text-sm font-bold tracking-wide text-secondary-100">订阅甜宠日报</h3>
            <p className="mt-4 text-sm leading-relaxed text-secondary-300">
              留下邮箱，每日推送最新上线的萌系、甜宠与恋爱漫画。
            </p>
            <form onSubmit={onSubmit} data-readdy-form="甜宠漫画每日更新订阅" className="mt-4">
              <div className="frm-guard" aria-hidden="true">
                <input
                  type="text"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                />
              </div>
              <div className="flex items-center overflow-hidden rounded-full bg-secondary-700/60">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder="你的邮箱"
                  aria-label="邮箱"
                  className="w-full min-w-0 bg-transparent px-4 py-2.5 text-sm text-secondary-50 outline-none placeholder:text-secondary-400"
                />
                <button
                  type="submit"
                  className="whitespace-nowrap bg-secondary-500 px-4 py-2.5 text-sm font-medium text-secondary-950 transition-colors hover:bg-secondary-400"
                >
                  订阅
                </button>
              </div>
              {status === "success" && (
                <p className="mt-3 text-sm text-secondary-300">{message}</p>
              )}
              {status === "error" && (
                <p className="mt-3 text-sm text-secondary-300">{message}</p>
              )}
            </form>
          </div>
        </div>
      </div>

      <div className="border-t border-secondary-700/60">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-4 py-5 text-xs text-secondary-400 sm:flex-row md:px-6">
          <p>© {new Date().getFullYear()} 可可漫画网 · 快乐追漫每一天</p>
          <p className="flex items-center gap-4">
            <span>联系邮箱：hello@keke-manga.example</span>
            <Link to="/about" className="transition-colors hover:text-secondary-200">
              关于我们
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
}